export { default as NBadge, badgeProps } from './src/Badge';
